<template>
  <div class="main-cover">
    <div class="main-cover__top">
      <p class="main-cover__top--year">{{ content.year }}</p>
      <h1 class="main-cover__top--title">{{ content.title }}</h1>
      <YellowLine class="main-cover__top--line" />
    </div>
    <h2 class="main-cover--dida">{{ content.dida }}</h2>
    <SwipeCta :label="content.mobileCta" @click="increment()" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import SwipeCta from "./coverComponents/SwipeCta.vue";
import YellowLine from "./coverComponents/YellowLine.vue";

export default {
  name: "MainCover",
  computed: {
    content() {
      return this.$t("landing");
    },
    ...mapGetters({
      landingIndex: "scroller/landingIndex",
    }),
  },
  methods: {
    ...mapActions({
      increment: "scroller/increment",
    }),
  },
  components: { SwipeCta, YellowLine,

  },
};
</script>

<style lang="scss" scoped>
.main-cover {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  color: $ui-white;
  text-align: center;

  &__top {
    width: 100%;
    flex-grow: 1;
    padding: 0 12vw;
    text-align: center;
    // avoid type to move
    &--line {
      margin-bottom: toRem(24);
    }

    &--year {
      margin-bottom: toRem(10);
      @include title-H5;
    }
    &--title {
      padding: 0 6vw;
      margin-bottom: toRem(25);
      @include title-H1;
    }
  }

  &--dida {
    padding: 0 18vw;
    color: $white-08;
    margin-bottom: toRem(49);
    @include dida-M;
  }
}

.tablet {
  .main-cover {
    &__top {
      padding: 0 15vw;
      &--year {
        @include title-H3;
      }
      &--title {
        padding: 0;
        @include title-H0;
      }
    }

    &--dida {
      @include dida-L;
    }
  }
}
</style>
